var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.item.data),function(record){return _c('v-row',{key:record.field,attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"4"}},[_vm._v(_vm._s(_vm.$localize("Project." + record.field)))]),_c('v-col',{attrs:{"cols":"8"}},[_vm._v(_vm._s(_vm.renderValue(record.field, record.new)))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }